// @ts-nocheck
import { TrackEventParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

const extendTrackEventParameters = <T extends TrackEventParameters<any, any>>(
    parameters: T,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const { currency, item_list_id, item_list_name, page_type } = parameters;

    Object.assign(options, {
        itemData: {
            currency,
            item_list_id,
            item_list_name,
            ...options?.itemData,
        },
    });

    return parameters;
};

export default extendTrackEventParameters;
